import React from "react"

import classes from "./footer.module.scss"
import SocialLinks from "../SocialLinks/socialLinks";

const Footer = () => {
  return (
    <footer className={classes.Footer}>
      <SocialLinks listStyleClass={classes.SocialLinks} />
    </footer>
  )
}

export default Footer
